import { Injectable } from '@angular/core';
import { customAlphabet } from 'nanoid';

@Injectable()
export class WorkspaceIdGeneratorService {
	private idMaxLength = 12;

	public constructor() {}

	public generateRandomId(): string {
		const nanoid = customAlphabet('abcdefghijklmnopqrstuvwxyz', this.idMaxLength);
		const ts = nanoid();
		return ts;
	}
}
